module.exports = "/images/facebook.svg?d5b9b70070520ec09008dfb997f7d7f6";